import { Routes } from '@angular/router';

import { SettingsComponent } from './settings/settings.component';
import { SimulatorComponent } from './simulator/simulator.component';
import { LeaderboardComponent } from './leaderboard/leaderboard.component';
import { TimemachineComponent } from './timemachine/timemachine.component';

export const routes: Routes = [
	{ path: '', component: SimulatorComponent },
	{ path: 'simulator', redirectTo: '/', pathMatch: 'full' },

	{ path: 'time-machine', component: TimemachineComponent },

	{ path: 'top-rankings', component: LeaderboardComponent },
	{ path: 'stats-for', redirectTo: '/top-rankings', pathMatch: 'full' },

	{ path: 'user-stats/:uid', component: LeaderboardComponent },

	{ path: 'settings', component: SettingsComponent },

	{ path: '**', component: SimulatorComponent },
];
